import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";
import { vars } from "../../../css/vars.css";

const Logo: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <img width={"190px"} src="https://app.swapkit.network/mainlogo.png" />
  );
};

export default Logo;
